import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.html",
  styleUrl: "./footer.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FooterComponent {
  protected readonly currentYear = new Date().getFullYear();
}
